import React from 'react';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { PhotoPrintsWindowDesktop } from './_desktop/PhotoPrintsWindowDesktop';
import { PhotoPrintsWindowMobile } from './_mobile/PhotoPrintsWindowMobile';

export const PhotoPrintsWindow = ({ close }: Props) => {
    const isMobile = useMobile();
    if (isMobile) {
        return <PhotoPrintsWindowMobile close={close} />;
    } else {
        return <PhotoPrintsWindowDesktop close={close} />;
    }
};

type Props = {
    close: () => void;
}; 